export const SERVICES = [
  {
    slug: "deep-tissue-massage",
    path: "/services/deep-tissue-massage",
    name: "Deep Tissue Massage",
    tagline: "Therapeutic Muscle Recovery & Deep Tension Release",
    metaTitle: "Deep Tissue Massage in Madhapur, Hyderabad | Blossom Spa",
    metaDescription:
      "Book a deep tissue massage at Blossom Spa Madhapur. Firm, targeted pressure to release chronic knots, ease back & shoulder stiffness. Call +91 7330619409.",
    heroImage:
      "https://images.unsplash.com/photo-1578413142862-c10be6467b8b?crop=entropy&cs=srgb&fm=jpg&q=85",
    cardImage:
      "https://images.unsplash.com/photo-1597010804526-2fcb8a09865b?crop=entropy&cs=srgb&fm=jpg&q=85",
    excerpt:
      "Firm, slow strokes that reach deep muscle layers to dissolve chronic tension and stubborn knots.",
    description:
      "Our Deep Tissue Massage is a focused therapy designed for guests carrying chronic tension, stiff shoulders, or a nagging lower back ache. Our trained therapists use slow, deliberate strokes and sustained pressure to reach the deeper layers of muscle and connective tissue, releasing adhesions that build up from long hours at a desk, intense workouts, or everyday stress.",
    benefits: [
      "Releases chronic muscle tension & stubborn knots",
      "Improves blood circulation to tired muscles",
      "Breaks down scar tissue & adhesions",
      "Eases lower back, neck & shoulder stiffness",
      "Restores mobility, flexibility & posture",
    ],
    process: [
      {
        title: "Consultation",
        text: "We discuss your problem areas, pain points and pressure preference before you lie down.",
      },
      {
        title: "Warm-Up Strokes",
        text: "Long, gliding strokes with warm oil prepare the muscles and ease you into the session.",
      },
      {
        title: "Deep Pressure Work",
        text: "Slow, concentrated pressure targets knots and deeper muscle layers using palms, knuckles & elbows.",
      },
      {
        title: "Cool Down",
        text: "A gentle closing sequence calms the nervous system and leaves you relaxed, not sore.",
      },
    ],
    durations: ["60 min", "90 min", "120 min"],
  },
  {
    slug: "thai-massage",
    path: "/services/thai-massage",
    name: "Thai Massage",
    tagline: "Ancient Stretch-Based Therapy for Energy & Flexibility",
    metaTitle: "Thai Massage in Madhapur, Hyderabad | Blossom Spa",
    metaDescription:
      "Experience traditional Thai Massage at Blossom Spa Madhapur — assisted stretching & acupressure along the Sen energy lines. Call +91 7330619409 to book.",
    heroImage:
      "https://images.unsplash.com/photo-1544161558-d5fa96ee28c6?crop=entropy&cs=srgb&fm=jpg&q=85",
    cardImage:
      "https://images.unsplash.com/photo-1590441703810-3e7fea239732?crop=entropy&cs=srgb&fm=jpg&q=85",
    excerpt:
      "Assisted stretching and rhythmic acupressure along the body's energy lines — practised fully clothed, without oil.",
    description:
      "Rooted in centuries-old Thai healing traditions, this therapy combines rhythmic acupressure with assisted, yoga-like stretches performed along the body's Sen energy lines. Practised on a floor mat without oil, it gently coaxes stiff joints and tight muscles into a greater range of motion while calming an overworked mind.",
    benefits: [
      "Increases flexibility & joint range of motion",
      "Stimulates energy flow along Sen lines",
      "Relieves stiffness without the use of oils",
      "Calms the nervous system & quiets the mind",
      "Improves posture, balance & circulation",
    ],
    process: [
      {
        title: "Consultation",
        text: "We check your flexibility, any injuries, and comfort with assisted stretching.",
      },
      {
        title: "Acupressure Opening",
        text: "Rhythmic palm & thumb pressure along energy lines awakens the body.",
      },
      {
        title: "Assisted Stretches",
        text: "Guided, yoga-inspired stretches open up the hips, spine and shoulders.",
      },
      {
        title: "Grounding Close",
        text: "Slow compressions and stillness bring the session to a calm finish.",
      },
    ],
    durations: ["60 min", "90 min", "120 min"],
  },
  {
    slug: "full-body-massage",
    path: "/services/full-body-massage",
    name: "Full Body Massage",
    tagline: "Holistic Head-to-Toe Relaxation Ritual",
    metaTitle: "Full Body Massage in Madhapur, Hyderabad | Blossom Spa",
    metaDescription:
      "Unwind with a full body massage at Blossom Spa Madhapur — long flowing strokes from head to toe for total relaxation. Call +91 7330619409 to book.",
    heroImage:
      "https://images.pexels.com/photos/15528975/pexels-photo-15528975.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    cardImage:
      "https://images.unsplash.com/photo-1790756548569-3c561d78f591?crop=entropy&cs=srgb&fm=jpg&q=85",
    excerpt:
      "A complete, head-to-toe ritual that blends long flowing strokes with gentle kneading for total-body calm.",
    description:
      "A signature Blossom ritual that treats the entire body — scalp, neck, back, arms, legs and feet — in one seamless, flowing sequence. Long gliding strokes are paired with gentle kneading to melt away everyday fatigue, leaving every muscle softened and your mind completely unplugged.",
    benefits: [
      "Full-body stress & fatigue relief",
      "Improved circulation from head to toe",
      "Deep, sustained state of relaxation",
      "Supports better, deeper sleep",
      "Soothes tired feet, legs, back & shoulders",
    ],
    process: [
      {
        title: "Welcome & Settle",
        text: "A warm welcome, soft lighting and calming aromas to help you unwind.",
      },
      {
        title: "Head-to-Toe Sequence",
        text: "Flowing strokes move systematically from scalp to feet in one continuous ritual.",
      },
      {
        title: "Pressure Point Focus",
        text: "Extra attention on the back, shoulders and feet — the body's biggest stress holders.",
      },
      {
        title: "Quiet Rest",
        text: "A few quiet minutes to rest before you step back into your day.",
      },
    ],
    durations: ["60 min", "90 min", "120 min"],
  },
  {
    slug: "aromatherapy-massage",
    path: "/services/aromatherapy-massage",
    name: "Aromatherapy Massage",
    tagline: "Essential Oil Elixirs for Mind & Body Harmony",
    metaTitle: "Aromatherapy Massage in Madhapur, Hyderabad | Blossom Spa",
    metaDescription:
      "Relax with an aromatherapy massage at Blossom Spa Madhapur using lavender, eucalyptus & sandalwood essential oils. Call +91 7330619409 to book.",
    heroImage:
      "https://images.unsplash.com/photo-1676852148076-7a92002419f3?crop=entropy&cs=srgb&fm=jpg&q=85",
    cardImage:
      "https://images.pexels.com/photos/672051/pexels-photo-672051.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    excerpt:
      "Therapeutic-grade essential oil blends paired with gentle strokes to calm the mind and nourish the skin.",
    description:
      "A sensory-led therapy that pairs gentle, flowing massage strokes with therapeutic-grade essential oils chosen for their calming, mood-balancing properties. As the fragrant blend is worked into the skin, tension dissolves and the mind settles into a state of deep, fragrant calm.",
    benefits: [
      "Reduces anxiety & mental fatigue",
      "Balances mood & emotional wellbeing",
      "Deeply nourishes & softens the skin",
      "Enhances the quality of sleep",
      "A soothing, fragrant sensory escape",
    ],
    oilsMenu: ["Lavender", "Eucalyptus", "Ylang Ylang", "Sandalwood"],
    process: [
      {
        title: "Scent Selection",
        text: "Choose from our curated oil blends based on your mood and needs.",
      },
      {
        title: "Warm Oil Massage",
        text: "Gentle, rhythmic strokes glide the warmed blend across the body.",
      },
      {
        title: "Breathwork Pauses",
        text: "Light pauses let the aroma settle, deepening relaxation.",
      },
      {
        title: "Fragrant Finish",
        text: "A calm, lingering sense of balance stays with you long after.",
      },
    ],
    durations: ["60 min", "90 min", "120 min"],
  },
];

export const getServiceBySlug = (slug) =>
  SERVICES.find((s) => s.slug === slug);
